<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <h2 mat-dialog-title>Riepilogo Invio Mail</h2>

  <div mat-dialog-content class="dialog-center-cont">
    <app-lista-tabellare
      #tabella
      [fnCaricamentoDati]="fnCaricamentoDati"
      [colonne]="colonne"
      [maxNrButton]="1"
      [defaultPageSize]="5"
      (bottoniListaClick)="bottoniListaClick($event)"
    >
      <ng-container btnEnd>
        <button
          mat-flat-button
          class="primary-button"
          color="primary"
          (click)="inviaTutteNonInviate()"
          [disabled]="data.isPermessoSoloRead"
        >
          <mat-icon matSuffix>mail</mat-icon>
          Invia a tutti
        </button>
      </ng-container>
    </app-lista-tabellare>
  </div>

  <div mat-dialog-actions class="dialog-footer-cont">
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
</div>
